import React from 'react'
import QuickLinks from 'components/shared/QuickLinks'
import { Row, Col } from 'antd'

export default function CompareBrokerQuickLinks({ brokers }) {
  return brokers.map((broker, idx) => {
    const linkList = []
    const {
      name,
      slug,
      commodity_trading: commodityTrading,
      currency_trading: currencyTrading,
    } = broker.attributes

    linkList.push({
      href: '/broker/[slug]',
      as: `/broker/${slug}`,
      linkText: ` ${name} Review`,
    })

    if (commodityTrading) {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: `/broker/${slug}/commodity-trading`,
        linkText: ` ${name} Commodity Trading`,
      })
    }
    if (currencyTrading) {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: `/broker/${slug}/currency-trading`,
        linkText: ` ${name} Currency Trading`,
      })
    }
    return (
      <Row style={{ marginBottom: '16px' }} key={idx}>
        <Col span={24}>
          <QuickLinks title={`${name} Quick Links`} linkList={linkList} />
        </Col>
      </Row>
    )
  })
}
